import { h } from 'preact';
import ResultModal from 'src/common/elements/ResultModal';
// import Logo from '../Logo';
import isMobileRender from 'src/common/helpers/isMobileRender';
import useResultRender from 'src/common/helpers/useResultRender';
import RenderWrapper from 'src/common/elements/RenderWrapper';
import Logo from 'src/app/components/Atoms/Logo';
import levels from 'src/app/constants/levels';
import { defaultRTP } from 'src/app/constants';
import resultToPath from 'src/app/helpers/resultToPath';
import pathToIndex from 'src/app/helpers/pathToIndex';

function Render() {
    const betData = useResultRender();
    if (!betData) return null;

    const {
        game: { level, rows, results, rtp },
    } = betData;
    const levetsByRtp = rtp ? levels[rtp] : levels[defaultRTP];

    const resultsArr = results.map((item: any) => {
        const path = resultToPath(item.result);
        const index = pathToIndex(path);
        return { ...item, index };
    });

    /* color */
    const centerColor = '#bcefff';
    const colors = ['#fdf77a', '#88fdee', centerColor];
    let colorsResult = [];
    const lengthPart = levetsByRtp[level][rows].length / 2;
    const lengthPartParticle = Math.ceil(lengthPart / colors.length);

    for (let i = 0; i < colors.length; i++) {
        for (let j = 0; j < lengthPartParticle; j++) {
            colorsResult.push(colors[i]);
        }
    }

    colorsResult = [...colorsResult, ...colorsResult.reverse()];
    while (colorsResult.length !== levetsByRtp[level][rows].length) {
        colorsResult.splice(colorsResult.indexOf(centerColor), 1);
    }

    const mobile = isMobileRender();

    const getCount = (index: number) => {
        let count = 0;
        for (let result of resultsArr) {
            if (Number(result.index) === Number(index)) {
                count += 1;
            }
        }
        return count;
    };

    return (
        <RenderWrapper>
            <ResultModal
                betData={betData}
                Logo={Logo}
                withHash={true}
                isMobile={mobile}
            >
                <div className="render-content">
                    {levetsByRtp[level][rows].map((item, index) => {
                        const count = getCount(index);
                        return (
                            <div
                                className="render-content__item"
                                style={{ '--local-color': colorsResult[index] }}
                            >
                                {count > 0 && (
                                    <>
                                        <div className="render-content__count">
                                            {count}
                                        </div>
                                        <div
                                            className={`render-content__particle render-content__particle--${level}`}
                                        />
                                    </>
                                )}
                                <div className="render-content__icon" />x{item}
                            </div>
                        );
                    })}
                </div>
            </ResultModal>
        </RenderWrapper>
    );
}

export default Render;
